import React from "react";
import { connect } from "react-redux";
import { withLocalize } from "react-localize-redux";

import BasePage from "common/components/Page";
import PageHeader from "common/components/PageHeader";
import { BreadcrumbsItem } from "common/components/Breadcrumbs";
import Content from "common/components/Content";
import i18n from "./i18n.json";

/* Privacy policy. */
class PrivacyPolicy extends BasePage {
  constructor(props) {
    // parent
    super(props);

    // load translations
    props.addTranslation(i18n);
  }

  render() {
    // parent
    super.render();

    // render
    return (
      <div>
        {this.props.location && (
          <div>
            <BreadcrumbsItem
              to={this.props.location.pathname}
              text={this.props.translate("privacyPolicy.header")}
            />
            <PageHeader text={this.props.translate("privacyPolicy.header")} />
          </div>
        )}

        <Content
          name="web.guardian.sitePrivacyPolicy"
          errorText={this.props.translate("privacyPolicy.errorLoading")}
          onSuccess={() => {
            this.setState({ textLoaded: true });
          }}
          onError={() => {
            this.setState({ textLoaded: false });
          }}
        />
      </div>
    );
  }
}

// turn this into a container component
PrivacyPolicy = withLocalize(connect()(PrivacyPolicy));

export default PrivacyPolicy;
